<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ getTitle() }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
    <div class="columns">
  <div class="column is-narrow" v-if="withLogo">
    <app-logo></app-logo>
  </div>
  <div class="column" :class="{ 'is-12': !withLogo }">
    <div class="columns">
      <div class="column" v-if="avecCode">
        <b-field :label="$t('parametrage.tab.code')"
          class="obligatoire mgb-0"
          expanded>
          <b-input ref="codeParametreGenerique" v-model="parametrage.code"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field :label="$t('parametrage.tab.libelle')"
          class="obligatoire mgb-0"
          expanded>
          <b-input ref="libelleParametreGenerique" v-model="parametrage.libelle"></b-input>
        </b-field>
      </div>
    </div>
  </div>
</div>
      <footer class="pdt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="saveParametre()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { create, update } from '@/api/parametre/';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import validation from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Logo from '@/components/general/Logo';

const Parametres = createNamespacedHelpers('parametres');
const Attachments = createNamespacedHelpers('attachments');

export default {
  props: {
    parametrage: {
      type: Object,
      required: true,
    },
    typeParametre: {
      type: String,
      required: true,
    },
    withLogo: {
      type: Boolean,
      required: false,
      default: false,
    },
    avecCode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    errorMsgComponent,
    appLogo: Logo,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      newParametreAdd: null,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    async saveParametre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        if (this.parametrage.id) {
          await update(this.typeParametre, this.parametrage);
          if (this.withLogo) {
            await this.updateAttachments(this.parametrage.id);
          }
          messageSuccess(this.$i18n.t('parametrage.successModification.' + this.typeParametre));
        } else {
          this.newParametreAdd = (await create(this.typeParametre, this.parametrage)).data.result;
          if (this.withLogo) {
            await this.setAttachmentElementId({ id: this.newParametreAdd.id });
            await this.insertAttachments(this.newParametreAdd.id);
          }
          messageSuccess(this.$i18n.t('parametrage.successCreation.' + this.typeParametre));
        }
        await this.loadParametreForce(this.typeParametre);
        loadingComponent.close();
        this.$emit('reloadParametrage', this.newParametreAdd);
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getTitle() {
      return this.parametrage.id ? this.$t('parametrage.EditLibelle.' + this.typeParametre)
        : this.$t('parametrage.addLibelle.' + this.typeParametre);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.withLogo && this.typeParametre) {
        await this.setAttachmentContext({ module: this.typeParametre.split('/')[1] });
        if (this.parametrage.id) await this.setAttachmentElementId({ id: this.parametrage.id });
      }
      this.$refs.libelleParametreGenerique?.focus();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
    }
  },
};

</script>
